module.exports = __webpack_public_path__ + "static/media/Icon awesome-github.f1e7888a.svg";